const ru = {
	"datalogger": {
		"cancel": "Отмена",
		"resetData": "Сбросить данные",
		"device_upgrade": "Обновление прошивки устройства",
		"batchAddScq": "Пакетное добавление регистратора данных",
		"updatefail": "Ошибка обновления, устройство не в сети.",
		"Normal1": "Статус онлайн",
		"deleteSuc": "Успешно удалено!",
		"county": "Округ",
		"Instruction": "Инструкция:",
		"select_file": "Пожалуйста выберите прошивку",
		"rebootDataloggerSuc": "Регистратор данных успешно перезапущен",
		"confirm_deldte": "После удаления сборщика данных у вас нет права управлять всеми данными, связанными с регистратором данных",
		"buyProfitNew": "Цена покупки электроэнергии",
		"datalogger_debug": "Отладка регистратора данных",
		"province": "Провинция/область",
		"clear_data": "Очистить данные",
		"Flowcard_status": "Статус flow card",
		"reAdd": "Повторно добавить",
		"connectionInfo": "Информация о подключении",
		"location_info": "Информация о местонахождении",
		"editDatalogger": "Модифицировать регистратор данных",
		"Status": "Статус",
		"Ple_Alias": "Пожалуйста, введите имя регистратора данных",
		"unbindResults": "Отвязка результатов",
		"editResults": "Изменить результаты",
		"upgrade": "Обновление",
		"edit": "Редактировать",
		"Offline": "Не в сети",
		"Online": "В сети",
		"timeZone": "Часовой пояс",
		"unbindDataloggerName": "Отвязать регистратор данных",
		"Communication_balance": "Коммуникационный баланс",
		"add_suc": "Добавлено успешно",
		"sellProfit": "Цена продажи электроэнергии:",
		"nominalPower": "Номинальная мощность",
		"Datalogger_List": "Список регистраторов данных",
		"installer": "Установщик",
		"delResults": "Удалить результаты",
		"reset": "Перезагрузить",
		"Datalogger_type": "Тип регистратора данных",
		"addResults": "Добавить результаты",
		"resetTitle": "Пожалуйста, введите YES, чтобы подтвердить, что вы хотите сбросить регистратор данных.",
		"upDatalogger": "Обновление регистратора данных",
		"datalogger_pn": "Номер регистратора данных:",
		"continueAdding": "Продолжить добавление",
		"resetCode": "Пожалуйста, введите YES для подтверждения",
		"city": "Город",
		"latitude": "Широта",
		"notActive": "Неактивно",
		"Upload": "Загрузить",
		"prompt_message": "Быстрое сообщение",
		"usr_belong": "Пользователь",
		"unitProfit": "Цена используемой электроэнергии:",
		"locationTip": "Полезный совет: если позиционирование является неточным или позиционирование не выполняется, вы можете ввести его вручную.",
		"basicInfo": "Личная информация",
		"Firmware_Version": "Версия прошивки",
		"upSuccessDatalogger": "Регистратор данных успешно обновлен",
		"unbindDataloggerExplain": "Эта функцияиспользуется, чтобы облегчить производителю отвязку тестовой учетной записи (владельца) от регистратора данных после предотгрузочной проверки. Пожалуйста, используйте эту функцию осторожно. После завершения операции заказчику необходимо повторно привязать регистратор данных.",
		"resetDataloggerExplain": "Эта функция спользуется для облегчения производителям очистки данных облачного тестирования оборудования. После сброса регистратора данных исторические данные устройства будут очищены. После срабатывания исторические данные устройства не могут быть восстановлены. Пожалуйста, будьте осторожны!",
		"resetResults": "Сбросить результаты",
		"currency": "Валюта дохода:",
		"copy": "Успешное копирование",
		"datalogger_name": "Имя регистратора данных:",
		"Datalogger_model": "Модель",
		"debug_suc": "Успешная отладка",
		"cp10": "Пожалуйста, введите название проекта",
		"address": "Адрес регистратора данных",
		"cp2": "Пожалуйста выберите часовой пояс",
		"cp1": "Выберите дату установки",
		"cp4": "Пожалуйста, выберите валюту",
		"more": "Больше",
		"cp3": "Пожалуйста, введите номинальную мощность",
		"cp6": "Пожалуйста, выберите проект",
		"cp5": "Пожалуйста, введите имя устройства",
		"finishAdding": "Завершить добавление",
		"cp7": "Выберите широту и долготу",
		"lonRange": "Число с долготой от - 180 до 180",
		"latRange": "Число широты от - 90 до 90",
		"upFailDatalogger": "Ошибка обновления регистратора данных",
		"Normal": "Нормальный",
		"cp9": "Введите текущий адрес",
		"resetSuc": "Сброс выполнен",
		"confirm": "Подтвердить",
		"modify_datalog": "Изменение информации в журнале данных",
		"activeStatus": "Активное состояние",
		"com_method": "Способ связи",
		"Debugfail": "Ошибка отладки, регистратор данных отключен!",
		"sellProfitNew": "Цена продажи электроэнергии:",
		"uploadSuccess": "Загрузка прошла успешно",
		"country": "Страна",
		"location_info1": "Географическая информация",
		"buyProfit": "Цена покупки электроэнергии:",
		"resetDataloggerName": "Сбросить регистратор данных",
		"Datalogger_Status": "Состояние регистратора данных",
		"editDataloggerName": "Редактировать регистратор данных",
		"modifySuc": "Успешно изменено",
		"Ple_PN": "Пожалуйста, введите номер PN регистратора данных",
		"devaddrfail": "Адрес для связи Поле не может быть пустым",
		"Allstate": "Все состояния",
		"longi_lati": "Долгота и широта",
		"create": "Создать",
		"finish": "Закончить",
		"install_date": "Дата установки",
		"such_as": "Введите свою команду, например: AA BB CC DD EE FF",
		"signal": "Сигнал",
		"longitude": "Долгота",
		"unbindSuc": "Отвязано успешно",
		"editSuc": "Изменение регистратора данных успешно",
		"add": "Создать устройство",
		"Offline1": "Статус офлайн",
		"enterPosition": "Входной адрес регистратора данных",
		"upBatchDataloggerTip": "Примечание: пакетное обновление предназначено для обновления одной и той же прошивки регистратора данных для нескольких регистраторов данных. Если вы не знаете, какая прошивка подходит для регистратора данных, свяжитесь с поставщиком!",
		"unbindTitle": "Пожалуйста, введите YES, чтобы подтвердить, что вы хотите отменить привязку регистратора данных к текущему владельцу терминала.",
		"update_suc": "Успешно обновлено",
		"flowCard": "Действительная карта не найдена",
		"Active": "Активно",
		"unbind": "Отвязать",
		"return_content": "Вернуть содержимое:",
		"district": "Административный район",
		"rebootDataloggerName": "Перезапустите регистратор данных",
		"send": "Отправить",
		"Datalogger_PN": "PN устройства",
		"generateProfitNew": "Цена генерации энергии",
		"Datalogger_Name": "Имя регистратора данных",
		"file_fist": "Сначала выберите прошивку",
		"income_info": "Информация о доходах",
		"timezone": "Часовой пояс",
		"addedSuccessfully": "Добавлено успешно",
		"unbindUsr": "Отвязка владельца",
		"Operation": "Работать",
		"GPRS_traffic": "GPRS-трафик",
		"delete": "Удалить",
		"nowNoAdd": "Не добавлять сейчас",
		"administrator": "Администратор",
		"dataloggerAddress": "Подробный адрес",
		"load": "Нагрузка",
		"addSuc": "Добавление регистратора данных успешно",
		"Datalogger_method": "Способ связи",
		"fixOnRebootDataloggerName1": "это",
		"fileExceed": "Превышен размер файла",
		"reboot": "Перезапуск",
		"generateProfit": "Цена генерации энергии:",
		"noNegative": "Введите негатив",
		"basic_info": "Личная информация",
		"debug": "Отладка",
		"fixOnRebootDataloggerName": "Подтвердите перезапуск регистратора данных:",
		"select_firmware": "Пожалуйста, выберите файл прошивки",
		"communication_address": "Адрес для связи:",
		"check": "Проверка",
		"InstructionType": "Формат инструкции",
		"endMarker": "Конечный маркер",
		"noMarker": "Без конечного маркера",
		"noCheck": "Без проверки",
		"InstructionIssue": "Отправка инструкции",
		"Insufficient": "Недостаточно количество",
		"add_datalogger": "Добавить регистратор данных",
		"currentAddress": "Текущий адрес:",
		"deleteTitle": "Удалить регистратор данных",
		"timezone1": "Часовой пояс",
		"addScq": "Добавить регистратор данных",
		"instruction_response": "Отправка инструкции, ожидание ответа...",
		"error1": "Загружать можно только файлы в форматах .bin и .hex!",
		"dataloggerTipName": "Коллектор добавлен, добавлен русский язык",
				"batch_edit_datalogger": "Пакетное редактирование регистратора данных",
				"upload_column_tips": "Напоминание: Столбец A — PN регистратора, Столбец B — количество нагрузок, Столбец C — скорость передачи, Столбец D — протокол связи, Столбец E — код производителя устройства, Столбец F — код производителя протокола, Столбец G — режим сбора, Столбец H — мин. адрес связи, Столбец I — макс. адрес связи, заголовок не нужен, см. изображение ниже",
				"upload_csv_tips": "Напоминание: Формат файла должен быть csv, см. изображение ниже",
				"click_enlarge": "Нажмите для увеличения",
						"collector_expire_time": "Время истечения срока коллектора",
						"collection_cycle": "Цикл сбора",
								"ascii_display": "Отображение ASCII:"
	},
	"constant": {
		"gmt_neg_5": "(GMT-05: 00) Восточное время (США и Канада), Индиана (Восток), Богота, Лима, Кито",
		"gmt_neg_4": "(GMT-04: 00) Атлантическое время (Канада), Куяба, Джорджтаун, Ла-Пас, Манаус, Сан-Хуан, Сантьяго, Асунсьон",
		"gmt_neg_7": "(GMT-07: 00) Чиуауа, Ла-Пас, Масатлан (старый), Горное время (США и Канада), Аризона",
		"gmt_neg_6": "(GMT-06: 00) Центральное время (США и Канада), Гвадалахара, Мехико, Монтеррей (старый)",
		"gmt_neg_1": "(GMT-01:00) Острова Зеленого Мыса, Азорские острова",
		"gmt_neg_3": "(GMT-03: 00) Бразилиа, Буэнос-Айрес, Гренландия, Кайенна, Форталеза, Монтевидео",
		"gmt_neg_2": "(GMT-02:00) Среднеатлантическое всемирное координированное время-02",
		"gmt_11": "(GMT +11:00) Магадан, Соломоновы острова, Новая Каледония",
		"gmt_55": "(Время по Гринвичу +05:30) Нью-Дели",
		"gmt_10": "(GMT +10:00) Брисбен, Владивосток, Гуам, Порт-Морсби, Хобарт, Канберра, Мельбурн, Сидней",
		"gmt_13": "(Время по Гринвичу +13:00) Нукуалофа",
		"gmt_12": "(GMT +12:00) Окленд, Веллингтон, Петропавловск-Камчатка-Старый, Фиджи, Всемирное координированное время +12",
		"gmt_neg_9": "(Время по Гринвичу-09:00) Аляска",
		"gmt_neg_8": "(GMT-08: 00) Тихоокеанское время (США и Канада), Нижняя Калифорния",
		"gmt0": "(GMT +00:00) Всемирное координированное время, Среднее время по Гринвичу, Дублин, Эдинбург, Лондон, Лиссабон, Касабланка, Монровия, Рейкьявик",
		"gmt_9": "(GMT +09:00) Осака, Саппоро, Токио, Сеул, Якутск",
		"gangbi": "гонконгский доллар (гонконгский доллар)",
		"gmt_7": "(GMT +07:00) Красноярск, Бангкок, Ханой, Джакарта",
		"gmt_8": "(GMT +08:00) Пекин, Чунцин, Гонконг, Урумчи, Куала-Лумпур, Сингапур, Перт, Тайбэй, Улан-Батор, Иркутск",
		"gmt_5": "(GMT +05:00) Ташкент, Екатеринбург, Исламабад, Карачи",
		"gmt_6": "(GMT +06:00) Алматы,Новосибирск,Астана,Дакка,Новосибирск",
		"gmt_65": "(GMT +06:30) Мьянма",
		"gmt_neg_11": "(GMT-11:00) Самоа, Всемирное координированное время-11",
		"gmt_3": "(GMT +03:00) Багдад, Кувейт, Эр-Рияд, Москва, ул. Санкт-Петербург, Волгоград, Найроби",
		"ruidian": "шведских крон (кр)",
		"gmt_neg_12": "(GMT-12:00) Международная линия перемены дат на запад",
		"gmt_4": "(GMT +04:00) Абу-Даби, Маскат, Ереван, Баку, Тбилиси, стандартное время Кавказа, Порт-Луи",
		"gmt_1": "(GMT +01:00) Амстердам, Берлин, Берн, Рим, Стокгольм, Вена, Белград, Братислава, Будапешт, Центрально-Западная Африка, Виндхук",
		"baxi": "Реальный ($)",
		"gmt_2": "(GMT +02:00) Амман, Бейрут, Дамаск, Хараре, Претория, Хельсинки, Киев, Рига, София, Таллинн, Вильнюс, Каир, Минск, Афины",
		"renminbi": "Юаней(￥)",
		"lubi": "РС(₹)",
		"gmt_neg_10": "(Время по Гринвичу-10:00) Гавайи",
		"Rand": "Рубли(RUB)",
		"moxige": "Мексиканское песо(Mex$)",
		"yingbang": "фунт стерлингов (£)",
		"Pakistani": "ПКР (рупий)",
		"aoyuan": "Австралийский доллар ($A)",
		"meiyuan": "Доллары США ($)",
		"ouyuan": "ЕВРО(€)"
	},
	"cloudsUpgarde": {
		"cloudsFirmwareList": "Список облачных обновлений",
		"cloudsFirmware": "Облачное обновление встроенного ПО"
	},
	"role": {
		"all": "Все",
		"viewer": "Наблюдатель за электростанцией",
		"plantOwnerNew": "Обычный пользователь",
		"plantOwner": "Владелец станции",
		"distributor": "Дистрибьютор",
		"group": "Групповой аккаунт",
		"manufacturer": "Аккаунт производителя"
	},
	"CollectorCountByOMSOrder": {
		"23": "Код производителя недействителен. Пожалуйста, свяжитесь с администратором",
		"12": "В заказе нет действительного PN-номера сборщика данных, пожалуйста, подтвердите номер заказа",
		"1": "Операция не удалась",
		"772": "Заказ уже имеет привязку. Пожалуйста, подтвердите, что регистратор данных в заказе не связан с другим аккаунтом",
		"259": "По этому заказу есть недействительные регистраторы данных. Пожалуйста, свяжитесь с администратором",
		"7": "Отказ платформы",
		"8": "Отклонено, обратитесь к администратору",
		"261": "Не удалось найти назначенного дистрибьютора, обратитесь к администратору"
	},
	"project": {
		"energyCurrent": "Текущая мощность",
		"tipCard": "Карта",
		"energyMonth": "Энергия месяца",
		"upload": "Загрузить",
		"createResults": "Создать результаты",
		"back": "Возвращаться",
		"project": "Проект",
		"createProject": "Создать проект",
		"deviceSn": "Серийный номер устройства",
		"createSuc": "Создание успешно",
		"modifySuc": "Успех",
		"delSuc": "Успешно удалено!",
		"upgradeSuc": "Успешно обновлено",
		"tipList": "Список",
		"moveSelect": "Переместить выбранное",
		"limit": "Размер изображения не более 1M",
		"placeholder": "Поиск имени устройства/SN/PN",
		"defaultProject": "Проект по умолчанию",
		"energyDate": "Энергия даты",
		"editSuc": "Успешное редактирование",
		"editProject": "Изменить проект",
		"move": "Сдвинуть",
		"energyTotal": "Общая энергия",
		"tipSearchPN": "Регистратор данных",
		"editResults": "Изменить результаты",
		"projectRemark": "Замечание по проекту",
		"manageProject": "Управление проектом",
		"upgradeResults": "Результат",
		"energyYear": "Энергия года",
		"delResults": "Удалить результаты",
		"delProject": "Удалить проект",
		"tipSearchSN": "По устройству",
		"projectName": "Название проекта",
		"choice": "Выбор",
		"projectId": "Идентификатор проекта",
		"moveTo": "Перейти к"
	},
	"Upload": {
		"Upload": "Загрузить"
	},
	"login": {
		"code": "Сдвиньте нижний ползунок, чтобы завершить головоломку.",
		"forgotUser": "Забыл аккаунт",
		"scanning": "Сканировать",
		"loginSuc": "Вход успешен",
		"pv123": "PV123 ЭСС",
		"YZcode": "Пожалуйста, введите проверочный код",
		"login": "Авторизоваться",
		"scan_download": "скачать приложение",
		"YHLogin": "Логин пользователя",
		"scan_login": "Вход по коду сканирования",
		"usr": "Имя пользователя",
		"SmartESS": "SmartESS",
		"forgotPwd": "Забыли пароль?",
		"app_download": "скачать приложение",
		"invitationLogin": "Вход с кодом exp",
		"pwdformat": "Неверный формат пароля (6<=цифр пароля<=32)",
		"usrformat": "Неверный формат учетной записи (2<=цифры учетной записи<=32)",
		"Pleaseconfirm_login": "Пожалуйста, подтвердите вход",
		"remember_pwd": "Запомнить меня",
		"YZcode_format": "неправильный формат проверочного кода. Пожалуйста, введите номер",
		"invitation": "Exp код",
		"no_invitation": "Еще нет кода exp? Пожалуйста свяжитесь с нами!",
		"signup": "Зарегистрироваться",
		"linkman": "Энергон",
		"sample_station": "Демо",
		"X_Tech": "X-Tech",
		"success": "Успех",
		"no_account_yet": "У вас нет аккаунта?",
		"Scancode_login": "Вход по коду сканирования",
		"pwd": "Пароль",
		"open": "открыть",
		"Swipe_right": "Проведите вправо",
		"no_validitycode": "Код приглашения не действителен.",
		"auto_login": "Автоматическая регистрация",
	},
	"customize": {
		"orange": "Оранжевый",
		"green": "Зеленый",
		"classic": "Розовый",
		"blue": "Синий",
		"purple": "Фиолетовый",
		"switchSkin": "Сменить скин"
	},
	"password": {
		"PLConfig_newpassword": "Пожалуйста, подтвердите новый пароль",
		"Current_password": "Старый пароль:",
		"User_name": "Имя пользователя:",
		"PLNew_password": "Пожалуйста, введите новый пароль",
		"New_password": "Новый пароль:",
		"Save": "Сохранить",
		"PLCurrent_password": "Пожалуйста, введите старый пароль",
		"editPwdSuc": "Пароль обновлен",
		"Config_newpassword": "Новый пароль:",
		"loginAgain": "Пароль был успешно изменен, пожалуйста, войдите снова",
		"Password": "Базовая информация"
	},
	"recharge": {
		"cancel": "Отмена",
		"early_warning": "Предупреждение об истечении срока действия карты flow card",
		"orderno": "Номер заказа",
		"Recharge_tip4": "Рекомендуется зарегистрированным пользователям Pay Pal.",
		"recharge_type": "Тип",
		"Recharge_tip3": "Рекомендуется пользователям микросхем.",
		"Recharge1": "Настройка перезарядки",
		"rechargeStatus": "Статус перезарядки",
		"Recharge_tip5": "Микроскопические платежи",
		"openWx": "Пожалуйста, откройте мобильный телефон WeChat",
		"Hint_language": "У вас есть 2G оборудование. По просьбе Министерства промышленности и информационных технологий 2G постепенно отходит от сети, рекомендуется купить и заменить оборудование 4G!",
		"rechMoney": "Пополнить",
		"Recharge": "Перезарядка",
		"Recharge_tip": "Напоминание о пополнении",
		"Dead_Time": "Время окончания",
		"domestic": "Внутренние",
		"not_for_the_time_being": "Отмена",
		"Hint_language1": "Если у вас возникли проблемы с пополнением, свяжитесь с горячей линией послепродажного обслуживания 0755 - 89993588",
		"rechDiscount": "Скидка",
		"Search": "Поиск",
		"warning": "Предупреждение",
		"Recharge_tip2": "Выберите, например, тот же номер ленты, что и 1; Тип карты 4G; В том же районе производится массовое пополнение карт трафика Китая на материке",
		"Recharge_tip1": "Поддерживаются только те же типы карт для массового пополнения",
		"rechScan": "Пожалуйста, откройте мобильный WeChat, чтобы завершить платеж",
		"rechTip": "Теплый совет: 1, один и тот же заказ может выбрать только один и тот же тип карты (например, в стране 4G), с той же загрузкой и тем же статусом платформы для борьбы с бедностью (по умолчанию отображается пакет с загрузкой 1 и без доступа к платформе для борьбы с бедностью); 2, пополнение просроченных карт и пополнение с 25 по 5 числа каждого месяца задерживается на 1 - 14 дней, пожалуйста, подождите",
		"Traffic_status": "Статус",
		"Status": "Статус flow card",
		"DataloggerPN": "PN",
		"Recharge_money": "Пополнить баланс",
		"Overdue": "Просрочено",
		"Cancel_recharge": "Отменить пополнение",
		"Datalogger_List": "Список регистраторов данных",
		"Recharged": "Пополнение успешно",
		"Rcharge_Month": "Месяц оплаты",
		"Service_Area": "Область обслуживания",
		"Datalogger_PN": "PN устройства",
		"rechargeDevice": "Регистратор данных :",
		"rechargeSucInfo": "Вы успешно заплатили, и трафик поступит в течение 24 часов.",
		"Confirm_recharge": "Подтверждение пополнения",
		"scan": "Отсканировать и полатить",
		"Paid": "Оплачено",
		"Time": "Время",
		"Unpaid": "Не оплачено",
		"Operation": "Работать",
		"Connecting_Devices": "Нагрузка",
		"Recharge_reminder": "Напоминание о пополнении",
		"scanComplete": "Пролистните, чтобы завершить платеж",
		"unknown": "Неизвестно",
		"rechargeChannel": "Канал :",
		"Signal": "Сигнал",
		"Plant": "Электростанция",
		"rechargeDiscount": "Скидка :",
		"expired": "Истекший",
		"load": "Нагрузка",
		"Recharge_List": "Список пополнения",
		"ccid": "CCID",
		"Order_Number": "Номер заказа",
		"Package_type": "Тип пакета",
		"Recharge_record": "Пополнение трафика",
		"DataloggerName": "Псевдоним",
		"Recharging": "Перезарядка",
		"Recharge_Selected": "Перезарядка",
		"rechargeErr": "Пожалуйста, выберите регистратор данных с таким же количеством нагрузок",
		"rechargePrice": "Цена :",
		"abroad": "За границей",
		"normal": "Нормальный",
		"previous": "Возвращаться",
		"CCID": "CCID",
		"CCID_time": "Срок действия flow card",
		"serial_number": "Нет",
		"Activation_Time": "Время активации",
		"confirm": "Подтвердить",
		"Recharge_status": "Статус перезарядки",
		"Recharge_now": "Пополнить счет сейчас",
		"Content_warning": "Дорогой пользователь! Обнаружено, что срок действия flow card используемого вами устройства скоро истечет. Если она не будет пополнена вовремя, flow card будет аннулирована оператором и не cможет быть использована дальше. Cвоевременно пополняйте баланс.",
		"Recharge_fail": "Ошибка перезарядки",
		"rechargePackage": "Упаковка :",
		"rechargeSuc": "Оплата прошла успешно",
		"pn": "PN устройства",
		"Tips": "Советы",
		"Recharge_successful": "Пополнение успешно",
		'Recharge_tip6': 'Наличие карт, не поддерживающих пополнение,Пожалуйста, свяжитесь с администратором.',
		'area_domestic': 'Континентальный Китай',
		'area_abroad': 'Международный',
				'remedy_title': 'Исправление заказа на пополнение',
				'upload_tip': 'Дружеское напоминание: Формат загружаемого файла — .txt'
	},
	"auxiliary": {
		"chartSupplement": "Реальный график",
		"auxiliaryFunction": "Вспомогательная функция",
		"realChart": "После открытия на графике отображаются реальные данные."
	},
	"rate": {
		"cancel": "Отмена",
		"buy_Rates": "Цена покупки мощности:",
		"device_status": "Состояние устройства",
		"generate_Rates": "Цена выработки электроэнергии:",
		"edit": "Редактировать",
		"Income_currencys": "Валюта дохода:",
		"sell_Rates": "Цена продажи мощности:",
		"datalogger_pns": "Номер регистратора данных:",
		"resetSuc": "Сброс выполнен",
		"sell_Rate": "Цена продажи мощности",
		"generate_Rate": "Цена выработки электроэнергии",
		"modifySuc": "Успешно изменено",
		"confirm": "Подтвердить",
		"buy_Rate": "Цена покупки мощности",
		"rate": "Ставка",
		"rate_list": "Список тарифов",
		"operating": "Работать",
		"Income_currency": "Валюта дохода",
		"datalogger_name": "Имя регистратора данных",
		"datalogger_pn": "Номер регистратора данных",
		"unbindSuc": "Отвязано успешно",
		"status": "Статус"
	},
	"intro": {
		"step_operate_1": "Более четкое расположение информации об оборудовании",
		"step_operate_2": "После выбора оборудования, вы можете быстро просмотреть схему потоков энергии, информацию об оборудовании, диаграмму данных, анализ параметров, подробные данные и информацию об аварийных сигналах оборудования.",
		"step_device_10": "Что удобно для вас, чтобы найти оборудование, которое вам важно",
		"step_project_5": "новый, изменить, удалить",
		"step_project_4": "Функции, управление оборудованием по позициям. Пользователи могут изменять проект",
		"slider_quite": "Выйти из загрузки",
		"step_project_3": "Управление проектом",
		"step_project_2": "Недавно добавленные",
		"step_project_1": "Управление составом новой системы",
		"step_device_6": "Находясь на устройстве, вы можете нажать «Подписаться»,",
		"step_device_7": "После предупреждения",
		"step_device_8": "Оборудование может быть использовано в этом проекте как",
		"slider_next": "Следующий шаг",
		"step_device_9": "Верхний",
		"new_guide": "Руководство для начинающих",
		"gaa_msg": "Напоминание о тревоге",
		"step_device_1": "Быстро найти интересующие устройства",
		"step_device_2": "Недавно добавленные",
		"step_device_3": "Сосредоточиться на оборудовании",
		"slider_enter": "Введите новую версию",
		"step_device_4": "Функция,",
		"step_device_5": "Наведите курсор мыши",
		"sys_msg": "Системное сообщение",
		"step_mode_3": "Список или карточка",
		"step_mode_4": "Вы можете выбрать способ презентации в соответствии с вашей ситуацией.",
		"step_mode_1": "Выберите свой любимый стиль списка устройств",
		"step_mode_2": "Доступ к списку устройств можно получить через",
		"slider_pre": "Предыдущий шаг",
				"unbind_tips": "Устройство не привязано к владельцу, сначала привяжите владельца",
		"device_code1": "Код устройства"
	},
	"alarm": {
		"Alarm_Msg": "Новое сообщение",
		"Alarm_Event": "Тревожное событие",
		"Intro_Msg": "Руководство для начинающих",
		"Alarm_Status": "Статус предупреждения",
		"alarmNum": "Количество тревожных событий",
		"alrmDes": "Описание фильтра тревожных сигналов",
		"deviceFilter": "Фильтр устройств",
		"tips": "Советы",
		"details": "Детали",
		"alarmDetails": "Детали тревоги",
		"alarmInfo": "Тревога",
		"alarmDevice": "Информация об устройстве",
		"Close": "Закрыть",
		"Device_PN": "PN устройства",
		"Battery": "Батарея",
		"Alarm_Type": "Тип события",
		"warning": "Предупреждение",
		"device_address": "Адрес устройства",
		"Camera": "Камера",
		"deviceType": "Тип устройства",
		"curSelected": "В настоящее время выбрано",
		"Status": "Статус",
		"all": "Все",
		"untreated": "необработанный",
		"alrmType": "Фильтровать тип тревожного сигнала",
		"delete_alarm": "Вы уверены, что хотите удалить это оповещение?",
		"Delete_selected": "Удалить выбранное",
		"Microinverter": "Микроинвертор",
		"faultTitle": "Количество ошибок за последние 7 дней",
		"warningTitle": "Количество тревожных событий за последние 7 дней",
		"Prevent_arcing_island": "Устройство защиты от island режима",
		"device_Warning": "Тревожный сигнал оборудования",
		"Occurrence_time": "Время появления",
		"device_Error": "Ошибка оборудования",
		"Alarm_Message": "Твой",
		"Alarm_List": "Список предупреждений",
		"alarmStatus": "Общее количество тревожных событий",
		"combining_manifolds": "Объединение коллекторов",
		"allAlarm": "Общее",
		"Device_Name": "Имя устройства",
		"Device_SN": "Серийный номер устройства",
		"Today_Alarm": "Тревожные события за сегодня",
		"Alarm_Read": "Вы прочитали все тревожные уведомления",
		"device_alias": "Псевдоним устройства",
		"Alarm_data": "На данный момент нет последних новостей",
		"ruleManage": "Управление правилами фильтрации тревожных сигналов",
		"device_Fault": "Сбой оборудования",
		"deletes": "Удалить",
		"User": "Пользователь",
		"Cancel": "Отмена",
		"timeSlot": "Временной интервал",
		"faultNum": "Количество ошибок",
		"Confirm": "Подтвердить",
		"ruleNew": "Новое правило",
		"Alarm_Describe": "Описание тревожного сигнала",
		"Operation": "Работать",
		"storage": "Контроллер накопления энергии",
		"error": "Ошибка",
		"Alarm_Message1": "Устройство появляется",
		"offline": "Не в сети",
		"Plant": "Электростанция",
		"clearHistory": "Очистить историю",
		"ruleName": "Название правила",
		"Charger": "Зарядное устройство",
		"Alarm_Code": "Код тревожного сигнала",
		"more": "Больше",
		"Device_Type": "Тип устройства",
		"endtime": "Время окончания",
		"fault": "Ошибка",
		"monitor": "Env-монитор",
		"inverter": "Инвертор",
		"filterHistory": "История фильтров",
		"processed": "Обработанный",
		"_Data": "Данные",
		"smart_meters": "Умные счетчики",
		"deleted_successfully": "Тревожный сигнал успешно удален",
		"view": "Посмотреть",
		"back": "Назад",
		"exportArchive": "Экспорт архивного оповещения",
		"archiveRecord": "Архив",
		"archiveTip": "Список включает все необработанные оповещения и обработанные записи за 7 дней"
	},
	"plantCode": {
		"successfulApplication": "Успешная заявка, пожалуйста, обратите внимание на ваш телефон или адрес электронной почты, мы свяжемся с вами как можно скорее",
		"goRegister": "Перейти к регистрации",
		"haveDevice": "Если у вас есть устройство, войдите в систему, чтобы использовать после регистрации",
		"code_is_required": "Требуется код exp",
		"useDemo": "Кода приглашения еще нет？Код приглашения предназначен только для демонстрации",
		"pleaseName": "Пожалуйста, введите ваше имя",
		"PleaseNumber": "Пожалуйста, введите свой номер телефона",
		"codeApplication": "Применение кода exp",
		"pleaseCode": "Пожалуйста, введите код приглашения",
		"PleaseEmail": "Пожалуйста, введите свой адрес электронной почты",
		"PleaseCompanyName": "Пожалуйста, введите название компании",
		"reasonNotEmpty": "Причина подачи заявки не может быть пустой",
		"applyNow": "Применить сейчас",
		"PleaseApplication": "Пожалуйста, опишите причину вашего обращения",
		"PleaseCompanyAddress": "Пожалуйста, введите адрес компании"
	},
	"firmware": {
		"Firmware_limit_format": "Разрешены только форматы файлов .bin, .hex и .s19",
		"Firmware_upload_fail": "Ошибка загрузки, пожалуйста, попробуйте снова!",
		"Firmware_upload_failTip": "Ошибка загрузки",
		"Firmware_limit1": "Вы можете загрузить не более",
		"Firmware_limit2": "файлов",
		"Firmware_limit3": "прошивки",
		"Firmware_limitM": "Размер отдельного файла прошивки не должен превышать",
		"cancel": "Отмена",
		"Select_file": "Выберите файл",
		"Upload1": "Загрузить файлы",
		"Size": "Размер (КБ)",
		"Firmware_desrc": "Описание",
		"upgrade_quit1": "Обновление закончилось ошибкой и было прекращено!",
		"deleteSuc": "Успешно удалено!",
		"Upload": "Загрузить",
		"del_firmware": "Удалить прошивку",
		"Upload_firmware": "Загрузить",
		"Operation": "Работать",
		"downloadFirmware": "Скачать",
		"tips": "Советы",
		"deleteFirmware": "Удалить",
		"Firmware_Version": "Версия",
		"Firmware_List": "Настройка прошивки",
		"limit1": "Загружать можно только файлы в формате xlsx",
		"limit2": "Подсказка: столбец A загруженного файла — это PN регистратора данных, а столбец B — псевдоним регистратора данных. Заголовок не требуется, как показано ниже.",
		"limit": "Только файлы .bin/.hex,не более 8M",
		"limit0": "Только файлы .bin/.hex/.s19,не более 8M",
		"FailedCancelUpgrade": "Не удалось отменить обновление",
		"Firmware_Lists": "Список прошивок",
		"uploadTips": "Пожалуйста, загрузите файл прошивки",
		"limit3": "Добавлено успешно",
		"Upload_Time": "Время загрузки",
		"Add_Firmware": "Добавить прошивку",
		"upgrading1": "Обновление соединения, пожалуйста, подождите",
		"Firmware_Name": "Название прошивки",
		"upgrading": "Обновление",
		"editFirmware": "Редактировать",
		"Firmware_description": "Описание прошивки:",
		"confirm": "Подтвердить",
		"upgrade_quit8": "Исключение обновления",
		"upgrade_quit7": "Неудачная попытка",
		"noRecord": "Нет записи",
		"upgrade_quit6": "Обновление отменено",
		"UploadTitle": "Пожалуйста, загрузите пакетные файлы",
		"enter_content": "Пожалуйста, введите содержание",
		"upgrade_quit5": "Не в обновлении",
		"upgrade_quit4": "Обновление было отменено вручную",
		"upgrade_quit3": "Успешно обновлено",
		"delete_firmware": "Вы точно хотите удалить прошивку?",
		"upgrade_quit2": "Ошибка обновления, повторите попытку позже!",
		"updateCompleted": "обновление завершено",
		"firmware_upgrade": "Обновление прошивки",
		"CancelUpgradeSuc": "Отмена обновления успешна",
		"error1": "Загружать можно только файлы в форматах .bin и .hex .s19!",
        "error2": " Please press LFU button",
		"CancelUpgradeSuc11": "Отменить обновление успешно, подождите, пока коллектор подключится к облаку, прежде чем обновиться",
		"upgrade_wait": "Идет подготовка к обновлению, подождите 1–2 минуты",
		"upgrade_wait1": "Подготовка к обновлению завершена. Дождитесь выхода сборщика данных в онлайн и повторно запустите задачу обновления",
		"colOffline": "Datalogger не в сети",
		"colUpgrading": "Уже выполняется обновление",
		"UpgradeStarting": "Обновление запущено, пожалуйста, подождите...",
		"upgradeSq_fail": "Обновление datalogger не удалось, попробуйте позже!",
	},
	"map": {
		"datalogger": "Имя регистратора данных:",
		"address": "Адрес:",
		"sn": "Серийный номер устройства:"
	},
	"group": {
		"cancel": "Отмена",
		"Delete": "Удалить",
		"note": "Примечание",
		"entername": "Пожалуйста, введите название группы",
		"deletegroup": "Удалить группу",
		"deletesuc": "Группа успешно удалена",
		"deleteConfirm": "Вы уверены, что хотите удалить эту группу?",
		"Operate": "Работать",
		"Group_name": "Имя группы",
		"Create_groups": "Создать группы",
		"editsuc": "Редактирование группы успешно",
		"Group_name1": "Имя группы:",
		"confirm": "Подтвердить",
		"userCount": "Количество пользователей",
		"Groups_list": "Список групп",
		"Edit_groups": "Редактировать группы",
		"creatsuc": "Группа успешно создана",
		"finish": "Закончить",
		"note1": "Примечание:"
	},
	"controlDeviceErrCode": {
		"11": "Нет разрешения, обратитесь к администратору",
		"1": "Операция не удалась. Пожалуйста, проверьте устройство и повторите попытку!",
		"2": "Время ожидания ответа истекло, попробуйте еще раз!",
		"3": "Система работает с ошибками. Пожалуйста, свяжитесь с администратором",
		"6": "Ошибка формата, обратитесь к администратору",
		"8": "Отклонено, обратитесь к администратору",
		"9": "Операция не поддерживается, обратитесь к администратору",
		"263": "Регистратор данных в настоящее время отключен. Пожалуйста, повторите попытку после подключения оборудования к сети!"
	},
	"control":{
		"setting": "Выпуск",
		"TouSetting": "Режим Работы Системы",
		"touCharge": "Приоритет Зарядки",
		"touPersonal": "Самопотребление",
		"touComplete": "Полная Подача в Сеть",
		"touClipping": "Срезание Пиков и Заполнение Впадин",
		"touOffgrid": "Автономное Приложение",
		"confirmModeSwitch": "Подтвердить Переключение Режима?",
		"modeSwitch": "Переключить Режим",
		"startTime": "Время Начала",
		"endTime": "Время Окончания",
		"paramValue": "Выберите Значение Параметра",
		"Monday": "Понедельник",
		"Tuesday": "Вторник",
		"Wednesday": "Среда",
		"Thursday": "Четверг",
		"Friday": "Пятница",
		"Saturday": "Суббота",
		"Sunday": "Воскресенье",
		"syncSetDay": "Синхронный Ежедневный Выпуск",
		"time": "Период Времени 1",
		"time1": "Период Времени 2",
		"time2": "Период Времени 3",
		"time3": "Период Времени 4",
		"time4": "Период Времени 5",
		"time5": "Период Времени 6",
		"setFail": "Выпуск Не Удался",
		"readFail": "Ошибка Чтения",
		"charge": "Зарядка",
		"discharge": "Разрядка",
		"reading": "Успешно Прочитано",
		"reading_loading": "Идет Чтение...",
		"pvMode": "Режим Подачи в Сеть",
		"screenshot": "Скриншот"
	},
	"statistic": {
		"All": "Все",
		"bc": "Загрузить данные",
		"normal": "Нормальный",
		"other": "Другой",
		"totalRegion": "Весь регион",
		"totalDevice": "Все устройства",
		"standby": "Режим ожидания",
		"regiontotal": "Общая площадь",
		"sy": "Данные устройства",
		"pv": "Данные солнечной панели",
		"active": "Активный",
		"allDevice": "Все устройства",
		"fault": "Ошибка",
		"generalAccount": "Владельцы Пользователи",
		"deviceStatus": "Состояние устройства",
		"allAccount": "Все пользователи",
		"offline": "Не в сети",
		"regionPercent": "Региональное соотношение",
		"bt": "Данные батареи",
		"inactive": "Неактивный",
		"Allstate": "Все состояния",
		"adminAccount": "Дистрибьютор Пользователь",
		"warning": "Предупреждение",
		"userActivity": "Уровень активности пользователей",
		"dataUpdateTime": "Время обновления данных",
		"gd": "Данные сети"
	},
	"settingalarm": {
		"Delete": "Удалить",
		"Add": "Добавить",
		"cancel": "Отмена",
		"Warning": "Предупреждение",
		"deletes": "Удалить",
		"Email": "Электронная почта",
		"Add_suc": "Добавление электронной почты успешно",
		"suredelete": "Удалить уведомление по электронной почте?",
		"Yes": "Да",
		"Fault": "Ошибка",
		"Operation": "Работать",
		"E_Mail": "Электронная почта:",
		"delete": "Удаление электронной почты успешно!",
		"chosesstation": "Пожалуйста, выберите электростанцию",
		"Receiving_Plant": "Электростанция получатель",
		"Plant": "Электростанция",
		"Alarm_Type": "Тип тревожного сигнала:",
		"create": "Создать",
		"Monthly_Report": "Ежемесячный отчет",
		"Add_Mailbox": "Добавить почтовый ящик",
		"No": "Нет",
		"Yearly_Report": "Годовой отчет",
		"edit": "Редактировать",
		"addEmails": "Добавить электронную почту",
		"Error": "Ошибка",
		"list": "Нет",
		"Email_Setting": "Настройка электронной почты",
		"Email_List": "Список адресов электронной почты",
		"Receiving_Report": "Получение отчета",
		"Alarm_Typetabel": "Тип события",
		"Delete_Mailbox": "Удалить почтовый ящик",
		"Daily_Report": "Ежедневный отчет"
	},
	"message": {
		"cancel": "Отмена",
		"pwd_is_required": "Пароль не может быть пустым",
		"id_is_required": "Группировка не может быть пустой",
		"email_info": "Пожалуйста, введите правильный адрес электронной почты в пределах 64 цифр",
		"delete_plant": "Удалить электростанцию",
		"Exporting_the_report": "Экспорт отчета",
		"length6_20": "Только 6-20 букв, цифр, подчеркивания могут быть введены",
		"length6_32": "Цифры от 6 до 32",
		"nodata": "Нет записей",
		"oldPass_wrong": "Старый пароль неверный, введите еще раз",
		"invitation_is_required": "Требуется код exp",
		"length2_32": "Цифры от 2 до 32",
		"pwdSame": "Старый и новый пароли не могут совпадать",
		"pn_is_required": "PN не может быть пустым",
		"pwdAgain": "Подтвердите пароль",
		"search": "Поиск",
		"pwdNotsame": "Два несоответствия входных паролей",
		"length2_64": "Цифры от 2 до 64",
		"uname_is_required": "Аккаунт не может быть пустым",
		"Logging_off": "Эта учетная запись отменена и не может войти в систему",
		"modify_plant": "Изменить электростанцию",
		"PN_info": "Номер PN имеет длину 14 или 18 бит, включая по крайней мере одну заглавную букву.",
		"confpwd_is_required": "Поле подтверждения пароля не может быть пустым",
		"mobile_is_required": "Номер телефона не может быть пустым",
		"email_is_required": "Электронная почта не может быть пустой",
		"country_is_required": "Выберите страну или регион",
	},
	"menu": {
		"datalogger": "Регистратор данных",
		"Total_user": "Всего пользователей:",
		"customize": "Настройка скорости обмена данных",
		"setting": "Настройки системы",
		"password": "Базовая информация",
		"rate": "Запись пополнения",
		"recharge": "Настройка мобильного",
		"record": "Пополнение трафика",
		"alarm": "Тревога",
		"firmwarenew": "Настройка прошивки",
		"adaptiveFirmware": "Адаптивная прошивка",
		"intelligenceUpgrade": "Умное обновление",
		"intelligenceUpgradeTitle": "Нет доступного пакета обновления, пожалуйста, свяжитесь с производителем",
		"intelligenceUpgradeTitle1": "Пожалуйста, подтвердите, должно ли устройство выполнить умное обновление?",
		"intelligenceUpgradeTitle2": "Подходящий пакет обновления не найден",
		"firmware": "Пользовательская настройка",
		"email": "Настройка аварийного оповещения",
		"myDevice": "Мое устройство",
		"overview": "Обзор",
		"functionalApplication": "Функциональное приложение",
		"mobile": "Настройка электронной почты",
		"pay": "Настройка перезарядки",
		"personal": "Параметр",
		"alarmSetting": "Изменить пароль",
		"home": "Вернуться к началу",
		"browseAccount": "Управление суб-аккаунтом",
		"cloudsUpgrade": "Облачное обновление",
		"strategy": "Настройка стратегии",
		"basic": "Личная информация",
		"device": "Устройство",
		"account": "Аккаунт",

		"log": "Журнал цифровых искателей",
		"actionLog": "Журнал операций",
		"Manufacturer": "Управление предприятием",
		"datalogger_list": "Список цифровых искателей",
		"manufacturer_account": "Счет производителя",
		"manufacturer_code": "Код производителя",
		"protocol_binding": "Привязка к протоколу цифрового искателя",
		"type_code": "Код типа цифрового искателя",
		"protocol_change": "Изменения в протоколе",
		"AIP_Interface": "Интерфейс интерфейса API",
		"protocol_operation": "Операционные инструменты протокола",
		"recharge_management": "Управление пополнением",
		"device_management": "Управление оборудованием",
		"KEY_List": "Список KEY",
		"Protocol_instruction": "Управление инструкциями протокола",
		"Raw_data": "Анализ исходных данных",
		"Recharge_remedy": "Восстановление после пополнения",
		"device_function": "Функция управления оборудованием",
		"Password_maintenance": "Сохранение пароля для элементов управления",
	},
	"signup": {
		"too_simple": "Пароль слишком простой, пожалуйста, введите еще раз",
		"code": "6-значный проверочный код",
		"qiangdu": "Надежность Пароля:",
		"di": "Слабый",
		"registered": "Зарегистрироваться",
		"login": "Авторизоваться",
		"confirm_Pwdpl": "Подтвердите пароль",
		"mobile_pl": "Номер телефона",
		"confirm_password": "Подтвердите пароль",
		"emailSignup": "Регистрация электронной почты",
		"PN_pl": "PN",
		"zhong": "Средний",
		"email_form": "в пределах 64 символов, введите точно, чтобы найти пароль.",
		"usr": "2-32 символа (английский, буква, цифра, подчеркивание)",
		"emailformat": "Пожалуйста, введите правильный почтовый ящик",
		"email": "Электронная почта",
		"pwdformat": "Ошибка формата пароля, 6~32 цифры (только цифры, буквы, подчеркивание)",
		"usrformat": "Ошибка аккаунта,2-32 цифры (только английский язык, буквы, цифры подчеркнуты)",
		"email_pl": "Адрес электронной почты",
		"pwd_pl": "Пароль",
		"Byte_2": "Участники",
		"pnformat": "Ошибка формата PN, 14 или 18 цифр (только цифры и буквы)",
		"Byte_1": "Уже введено",
		"phoneSignup": "Регистрация по телефону",
		"mobileformat1": "Пожалуйста, введите правильный номер мобильного телефона",
		"mobileformat": "Неверный формат номера телефона (6-32 цифры)",
		"qiang": "Сильный",
		"code_pl": "Проверочный код",
		"confirm_pl": "Подтвердите пароль",
		"signup": "Зарегистрироваться",
		"phone": "Телефон",
		"success": "Успешная регистрация!",
		"usr_pl": "Имя пользователя",
		"phone_form": "в пределах 32 символов, введите точно, чтобы найти пароль.",
		"Register_account": "Зарегистрировать аккаунт",
		"existing_account": "У вас уже есть аккаунт?",
		"pwd": "6-32 символа (цифра, буква, подчеркивание), с учетом регистра",
		"pn": "14 или 18 символов (только цифры и буквы)",
		"country_pl": "Страна или регион",
	},
	"version": {
		"to_new": "Новая версия",
		"to_old": "Предыдущая версия",
		"custom_theme": "Пользовательская тема",
		"default_theme": "Тема по умолчанию",
		"default_node": "Узел по умолчанию"
	},
	"createPlant": {
		"fileExceed": "Превышен размер файла",
		"Control_settings": "Настройка аккумулятора",
		"basic_settings": "Базовая настройка",
		"Basic_setting": "Базовая настройка",
		"select_all": "Выбрать все",
		"pv": "PV",
		"gd": "Сеть",
		"bt": "Батарея",
		"bc": "Нагрузка",
		"sy": "Система",
		"eg": "Генератор",
		"hl": "ДомашняяНагрузка",
		"System_settings": "Настройки системы",
		"Grid_settings": "Настройка сети",
		"Solar_settings": "Настройка солнечной системы",
		"imageLimit": "Изображения только jpg, png и не могут превышать 8Mб",
		"Load_setting": "Загрузить настройку",
		"Standard_setting": "Стандартные настройки",
		"other_settings": "Другая настройка",
		"Advanced_setting": "Расширенные настройки",
		"Battery_settings": "Настройка батареи",
		"Battery_settingsTT": "Общие настройки аккумулятора",
		"Battery_settings1": "Аккумуляторная батарея 1",
		"Battery_settings2": "Аккумуляторная батарея 2",
		"Work_settings2": "Установить рабочий статус системы",
		"Machine_settings2": "Включить режим ожидания машины",
		"Clear_settings2": "Очистить ошибку",
		"uploadSuccess": "Загрузка прошла успешно"
	},
	"upgradeManagement": {
		"cancel": "Отмена",
		"eidt_success": "Успешное редактирование",
		"delete_success": "Ценный успех",
		"edit_firmware": "Редактировать",
		"delete_success1": "Успешно удалено!",
		"download_firmware": "Скачать",
		"upgrade_file_format1": "Можно загрузить только в . bin/. шестнадцатеричный формат",
		"upgrade_file_format2": "Размер файла не может превышать 1 МБ",
		"Upload": "Загрузить",
		"Firmware_Version": "Версия",
		"firmwareName_empty": "Имя встроенного ПО не может быть пустым",
		"confirm": "Подтвердить",
		"upgrade_file_format": "Можно загрузить только в . bin/. шестнадцатеричный формат, не может превышать 1 МБ",
		"firmware_name": "Название встроенного ПО",
		"Remarks": "Описание",
		"please_upgrade": "Пожалуйста, выберите загружаемый файл",
		"download_firmware_prompt": "Вы уверены, что хотите загрузить эту прошивку?",
		"upload_firmware": "Загрузить",
		"create": "Создать",
		"please_input": "Пожалуйста, введите",
		"firmwareVersion_empty": "Номер версии не может быть пустым",
		"download_success": "Успешная загрузка",
		"delete_desc": "После удаления восстановить его будет невозможно, и стратегия обновления, выбранная для данной прошивки, не позволит обновить устройство",
		"upgrade_success": "Успешная загрузка",
		"download_exception": "Скачать аномалию, попробуйте позже",
		"upload_result": "Результат загрузки",

	},
	"401": {
		"goback": "Назад к предыдущему",
		"gohome": "Вернуться к началу",
		"oops": "Ой!",
		"noAuth": "Вы не имеете доступа к этой странице"
	},
	"errCode": {
		"271": "Нет операции модификации",
		"272": "Повторить привязку",
		"273": "Не поддерживает добавление для других производителей",
		"352": "Не могу найти прошивку",
		"353": "Роль не найдена",
		"276": "Не поддерживает владельцев электростанций, у которых есть мобильные устройства с другими производителями.",
		"512": "Несоответствие кода аутентификации SMS",
		"513": "Срок действия кода подтверждения истек",
		"514": "Несоответствие номера телефона/электронной почты",
		"515": "Номер телефона/электронная почта не привязана",
		"516": "Имя не может совпадать",
		"517": "В системе есть номер регистратора данных под такого же пользователя или электростанцию",
		"518": "У пользователя также есть подчиненный пользователь",
		"519": "повтор аккаунта",
		"10": "Не удалось пройти аутентификацию, пожалуйста, войдите снова",
		"11": "Неподдерживаемые операции",
		"12": "Нет записи",
		"13": "За пределами",
		"14": "Повторные операции",
		"15": "Нет ключа производителя",
		"16": "Ошибка проверки пароля",
		"17": "Ошибка формата пароля",
		"18": "Номер телефона привязан",
		"1792": "Сборщик данных должен принадлежать дистрибьютору",
		"19": "Ошибка формата номера телефона",
		"1031": "Пользователь не создан этим администратором",
		"1030": "Недействительная GPRS-карта",
		"0": "Нормально, без ошибок",
		"1029": "Неподдерживаемая перезарядка",
		"1": "Ошибка",
		"1028": "Повторяющееся количество номеров цифрового регистратора данных",
		"288": "Не могу найти камеру",
		"2": "Спустя время",
		"1027": "Высший пользователь должен быть дистрибьютором или производителем оборудования",
		"520": "Дублирующийся PN-номер",
		"3": "Система работает с ошибками. Пожалуйста, свяжитесь с администратором",
		"1026": "Поддержка только для производителей оборудования",
		"521": "Получатель не принадлежит пользователю",
		"4": "Не проверяющая подпись",
		"1025": "Поддержка только для дилеров",
		"522": "Номер регистратора данных уже существует",
		"368": "Невозможно найти соглашение",
		"5": "Значение указано неверно и используется не по правилам",
		"1024": "Не учетная запись браузера",
		"523": "Поддержка только для владельцев электростанции",
		"369": "Группы пользователей не найдены",
		"6": "Ошибка формата параметра",
		"7": "Отказ платформы",
		"525": "Код подтверждения отправлен. Повторите попытку позже.",
		"528": "Роль привязана к пользователю и не может быть удалена",
		"8": "Непривилегированная операция",
		"768": "В протоколе нет необязательных полей",
		"9": "Отсутствие необходимых параметров",
		"20": "Ошибка формата учетной записи",
		"21": "Ошибка формата учетной записи (2 <= цифры учетной записи < 32)",
		"22": "Ошибка формата названия компании",
		"23": "Код производителя недействителен",
		"24": "повтор аккаунта",
		"25": "Аккаунт отключен, обратитесь к администратору",
		"26": "E-mail уже привязан, пожалуйста, измените e-mail или отмените привязку.",
		"27": "Аккаунт был аннулирован. Пожалуйста, свяжитесь с администратором",
		"1042": "Недействительный CCID",
		"1041": "Ключ неисправен или не может быть найден",
		"370": "Не удается найти группу электростанций",
		"371": "Пакет пополнения GPRS-трафика не найден",
		"372": "Заказ пополнения не найден",
		"772": "Сборщик данных был связан",
		"256": "Нет записей",
		"257": "Оборудование не найдено",
		"258": "Не удается найти устройство",
		"259": "Неверный номер PN, проверьте правильность номера PN",
		"260": "Ни одна электростанция не может быть найдена",
		"261": "Не удалось найти пользователя",
		"262": "Оборудование отключено",
		"384": "Ошибка кода подтверждения",
		"263": "Регистратор данных отключен",
		"385": "Не удается найти device_token",
		"264": "Нет сигналов для оборудования",
		"386": "Не удается найти информацию о конфигурации устройства",
		"265": "Детектор окружающей среды не найден",
		"387": "Не удается найти тип регистратора данных"
	},
	"report": {
		"cancel": "Отмена",
		"select_date": "Пожалуйста выберите дату",
		"Yearly_Report": "Годовой отчет",
		"Export_report": "Экспорт отчета",
		"Export_alarm": "Экспорт тревоги",
		"Report_date": "Дата отчета:",
		"no_deAlarm": "За последний месяц ни одного тревожного сигнала устройства не возникало",
		"Report_date1": "Примечание. Диапазон дат экспорта не может превышать 31 дня.",
		"Total_report": "Общий отчет",
		"Subscribe_report": "Подписаться на отчет",
		"customize": "Настроить",
		"all_reports": "Экспортировать все",
		"current": "Текущий",
		"download": "Ожидание загрузки, пожалуйста, подождите",
		"Report_type": "Тип отчета:",
		"Export": "Экспорт",
		"Daily_report": "Ежедневный отчет",
		"to": "К",
		"Batch_export": "Пакетный экспорт",
		"Monthly_report": "Ежемесячный отчет",
		"End_date": "Дата окончания",
		"start_date": "Дата начала"
	},
	"404": {
		"notFound": "Страница не найдена!"
	},
	"retrieve": {
		"Verification_code": "Проверочный код",
		"passwordPhone": "Номер мобильного телефона не привязан",
		"Email": "Электронная почта",
		"enter_code": "Пожалуйста, введите проверочный код",
		"re-register": "Перерегистрировать",
		"login": "Авторизоваться",
		"Reset_successfully": "Сброс выполнен успешно, пожалуйста, запомните свой пароль",
		"Retrieve_passwordEmail": "Восстановить пароль по электронной почте",
		"bound_mobile": "Пожалуйста, введите связанный номер мобильного телефона",
		"Retrieve_password": "Получить пароль",
		"passwordPhone1": "Номер мобильного телефона не совпадает",
		"Confirmloginpassword": "Подтвердите новый пароль для входа",
		"Get_codeSucc": "Проверочный код успешно получен",
		"New_password": "Новый пароль",
		"email_first": "Пожалуйста, сначала заполните адрес электронной почты",
		"code_1minute": "Код подтверждения был отправлен на ваш мобильный телефон, и ввод действителен в течение 1 минуты.",
		"finish": "Закончить",
		"Retrieve_passwordPhone": "Пароль получен мобильным телефоном",
		"bound_email": "Пожалуйста, введите привязанный адрес электронной почты",
		"Email_verification": "Подтверждение адреса электронной почты",
		"step4": "Шаг 4",
		"code_5minutes": "Код подтверждения был отправлен на вашу электронную почту, и запись действительна в течение 5 минут.",
		"Getting_progress": "Выполняется, пожалуйста, подождите.",
		"Confirm_password": "Подтвердите пароль",
		"reset_Password": "Сброс пароля",
		"enter_name": "введите одно имя пользователя",
		"mobile_first": "Пожалуйста, сначала заполните номер мобильного телефона",
		"Phone_verification": "Проверка телефона",
		"Reset_passwordSuc": "Сброс пароля успешен!",
		"step2": "Шаг 2",
		"step3": "Шаг 3",
		"signup": "Зарегистрироваться",
		"step1": "Шаг 1",
		"confirm": "Подтвердить",
		"account_password": "Пожалуйста, введите учетную запись, необходимую для восстановления пароля",
		"Change_one": "Изменить один",
		"Obtain_code": "Получить код",
		"Incorrect_code": "Неверный код подтверждения",
		"new_password": "Новый пароль",
		"passwordEmail1": "Несоответствие почтового ящика",
		"passwordEmail": "Непривязанный почтовый ящик",
		"Newloginpassword": "Новый пароль",
		"phone_number": "Номер телефона",
		"Verify_identidy": "Подтвердить личность",
		"Enter_account": "Войти в аккаунт",
		"Con_password": "Подтвердите пароль",
		"username": "Имя пользователя"
	},
	"header": {
		"log_out": "Выйти",
		"change_password": "Изменить пароль",
		"plant_owner": "Владелец станции",
		"operating_manual": "Руководство",
		"bind_email": "Привязать электронную почту",
		"bind_mobile": "Привязать мобильный",
		"skin": "Сменить скин",
		"shopping_mall": "Торговый центр",
		"pnAndAlias": "PN / название",
		"pnAndSN": "PN / SN",
		"personal_infor": "Параметр",
		"pleaseSelect": "Выбрать",
		"language": "Язык",
		"pleaseSelect1": "Выберите время"
	},
	"basic": {
		"backTo": "Возвращаться",
		"Change_email": "Изменить e-mail",
		"Email": "Электронная почта:",
		"uploadAvatar": "Изменить аватар",
		"editNickname": "Изменить псевдоним",
		"bindPhone": "Привязать телефон",
		"bindPhoneTip": "Настройте мобильный телефон для входа в систему и получения пароля, а также для получения уведомления, отправляемых системой.",
		"changePwdSuc": "Сброс пароля успешен!",
		"accountSecurity": "Безопасность учетной записи",
		"modifySuc": "Успешно изменено",
		"Personal_info": "Личная информация",
		"bindPhoneTipAfter": ", вы можете войти в систему, восстановить свой пароль и получать уведомления, отправляемые системой.",
		"Nickname": "Псевдоним:",
		"bindEmailTipBefore": "Привязанная электронная почта",
		"email_code": "Код подтверждения был отправлен на вашу электронную почту, пожалуйста, проверьте его",
		"unbinding_Em": "После отвязки вы не сможете использовать электронную почту для восстановления пароля!",
		"Bind_phone": "Привязать мобильный",
		"After_bindingPh": "Пароль можно восстановить через привязанный телефон",
		"code_frequently": "Коды подтверждения запрашиваются слишком часто, повторите попытку позже.",
		"finished": "Закончить",
		"Ple_Nickname": "Пожалуйста, введите псевдоним",
		"bindRes": "Привязать результат",
		"changeBtn": "Редактировать",
		"setMobile": "Привязать номер мобильного телефона",
		"Ple_email": "Пожалуйста, введите адрес электронной почты для привязки",
		"unbind_Ph": "Вы уверены, что хотите отменить привязку своего номера телефона?",
		"Bind_email": "Привязать электронную почту",
		"re_enter": "Повторно получить",
		"Obtain_code": "Получить код",
		"Change_phone": "Изменить телефон",
		"noHanzi": "Пароль не может содержать китайский",
		"setNickname": "Установить псевдоним",
		"suc_em": "Электронная почта успешно привязана",
		"Save": "Сохранить",
		"basic": "Параметр",
		"bindEmail": "Привязать электронную почту",
		"mobile_code": "Код подтверждения был отправлен на ваш мобильный, пожалуйста, проверьте его",
		"code": "Код:",
		"setEmail1": "Привязать электронную почту",
		"unbind_Em": "Вы уверены, что хотите отменить привязку электронной почты?",
		"Untie_phone": "Отвязать телефон",
		"basicInfo": "Личная информация",
		"changePwd": "Изменить пароль",
		"unbinding_Ph": "После отвязки вы не сможете использовать телефон для восстановления пароля",
		"bindPhoneTipBefore": "Привязанный телефон:",
		"Ple_phone": "Пожалуйста, введите телефон для привязки",
		"Email1": "Электронная почта",
		"Email2": "Электронная почта:",
		"Select_all": "Восстановить и выбрать все",
		"retry": "Повторить попытку",
		"editMobile": "Изменить номер мобильного телефона",
		"Ple_code": "Пожалуйста, введите проверочный код",
		"editEmail": "Изменить электронную почту",
		"User_name1": "Имя пользователя",
		"personalCenter": "Настройки учетной записи",
		"changePwdTip": "Пароль с высоким уровнем безопасности может сделать учетную запись более безопасной. Рекомендуется регулярно менять пароль и устанавливать пароль длиной от 6 до 32 цифр.",
		"suc_ph": "Телефонный номер успешно привязан",
		"changeRes": "Изменить результаты",
		"bindEmailTip": "Настройте электронную почту, чтобы войти в систему и получить пароль, а также получать уведомления, отправляемых системой.",
		"Unbind_email": "Отменить привязку электронной почты",
		"Mobile": "Мобильный",
		"Avatar": "Изображение пользователя",
		"Mobile1": "Номер телефона",
		"Nickname1": "Псевдоним",
		"User_name": "Имя пользователя:",
		"After_bindingEm": "Пароль можно получить через связанное электронное письмо",
		"Nickname_length_tip": "Длина пользовательского прозвища 2 ~ 32 бита"
	},
	"strategy": {
		"cancel": "Отмена",
		"Not_upgraded": "Не обновлен",
		"strategy_number": "Номер",
		"force_upgrade": "Принудительное обновление",
		"strategyIntro": "Обзор процесса локального обновления",
		"message_baudrate": "Пожалуйста выберите скорость обмена данными",
		"In_effect": "В действительности",
		"view": "Смотреть",
		"strategyUpgrade": "Список стратегий обновления",
		"stategyStep9": "Просмотр состояния и результатов обновления устройства",
		"message_name": "Пожалуйста, введите название полиса",
		"cancel_strategy": "Отменить политику",
		"uprade_name": "Принудительное обновление",
		"stategyStep8": "Просмотр записей об обновлении",
		"edit_strategy": "Редактировать политику",
		"stategyStep7": "Добавьте новую стратегию в список стратегий обновления, выберите Обновить встроенное ПО, установите метод обновления и он вступит в силу, свяжите устройство обновления и сгенерируйте стратегию обновления",
		"stategyStep6": "Добавить стратегию",
		"message_desc": "Пожалуйста, введите описание политики",
		"stategyStep5": "После того, как стратегия вступит в силу, приложение получит напоминание об обновлении и сможет выполнить обновление локально",
		"suggested_upgrade": "Предлагаемое обновление",
		"stategyStep4": "Локальное обновление приложения",
		"add_strategy": "Список стратегий обновления",
		"stategyStep3": "Загрузите файлы пакета версий встроенного ПО в локальное управление встроенным ПО",
		"stategyStep2": "Пакет новой версии встроенного ПО",
		"End_date": "Дата истечения срока действия",
		"Upgrade_tip": "Пожалуйста, выберите устройство, связанное с политикой",
		"edit": "Редактировать",
		"uprade_success": "Успешно обновлено",
		"strategy_firmware": "Обновление встроенного ПО",
		"upgrade_remind": "Напоминание об обновлении",
		"message_timezone": "Пожалуйста выберите часовой пояс",
		"message_type": "Пожалуйста, выберите тип прошивки",
		"go_back": "Возвращаться",
		"Upgrade_result": "Добавлено успешно",
		"uprade_time": "Время обновления",
		"message_uprade_type": "Пожалуйста, выберите тип обновления",
		"stategyDetail7": "Статус",
		"message_firmware": "Пожалуйста выберите прошивку",
		"start_time": "Время начала",
		"stategyDetail6": "Прогресс обновления",
		"stategyDetail5": "Метод",
		"uprade_status": "Статус обновления",
		"stategyDetail4": "Скорость передачи данных в бодах",
		"TOP": "Предыдущий шаг",
		"completion_strategy": "Стратегия завершения",
		"delete_firmware": "Вы уверены, что хотите отменить эту политику?",
		"stategyDetail9": "Время окончания",
		"Next": "Следующий шаг",
		"stategyDetail8": "Время начала",
		"strategy_desc": "Описание",
		"strategy_detail": "Детали стратегии",
		"strategy_status": "Статус",
		"Yes_started": "Модернизированный",
		"strategy_baudrate": "Скорость передачи данных в бодах",
		"UpgFirmware": "Локальное управление встроенным ПО",
		"delete_desc": "После отмены восстановление будет невозможно, и выбранная стратегия обновления не сможет уведомить устройство об обновлении",
		"strategy_name": "Имя",
		"remind_desc": "Описание напоминания",
		"strategy_search": "Код политики/Название политики",
		"uprade_type": "Метод",
		"uprade_result": "Результат",
		"associated_device": "Связанные устройства",
		"stategyDetail3": "Тип встроенного ПО",
		"stategyDetail2": "Размер встроенного ПО (КБ)",
		"stategyDetail1": "Обновление встроенного ПО",
		"upgradeList": "Список записей обновления",
		"message_time": "Пожалуйста, выберите действительное время",
		"expired": "Истекший",
		"strategyIntro1": "Описание: Этот функциональный модуль предназначен только для обновления локальной прошивки Bluetooth. Если вы хотите обновить встроенное по таких устройств, как Wi-Fi или 4G, пожалуйста, перейдите к [Управление устройствами Операция обновления списка устройств]",
		"uprade_name1": "Предлагаемое обновление",
		"view_strategy": "Просмотр политик",
		"strategy_code": "Код",
		"upgrade_strategy_list": "Список стратегий обновления",
		"start_date": "Дата вступления в силу",
		"default_desc1": "Это устройство необходимо обновить до более поздней версии, прежде чем его можно будет использовать. Нажмите на \"Принудительное обновление\", чтобы выполнить обновление. Пожалуйста, не отключайте Bluetooth-соединение и обеспечьте бесперебойную работу сети во время обновления.",
		"strategyInfor": "Информация о политике обновления",
		"policy_information": "Информация о политике",
		"end_time": "Время окончания",
		"strategy_type": "Тип встроенного ПО",
		"strategy_upgrade_search": "Устройство SN/регистратор данных PN",
		"confirm": "Подтвердить",
		"strategy_time": "Эффективное время",
		"Not_started": "Не запущен",
		"uprade_fail": "Неудачная попытка",
		"stategyDetail": "Имя",
		"default_desc": "Описание по умолчанию",
		"to": "Возвращаться",
		"limits":"Подсказка: в загружаемом файле столбец A должен содержать PN датчика, заголовок не требуется; см. пример на изображении ниже.",
		"mueas":      "Стратегия обновления",
		"upNum":      "Количество устройств для обновления",
		"deletCL":    "Удалить стратегию",
		"deletCL_TEST":"Вы уверены, что хотите удалить эту стратегию?",
		"ONE_UP":     "Обновление одного устройства",
		"MO_UP":      "Массовое обновление устройств",
		"MO_text": "Успешно импортировано",
"MO_tex1": "Повторяющийся",
"MO_tex3": "Не найдено",
"MO_tex2": "Организация",
"MO_tex4": "Прошивка используется в активной политике, удаление невозможно",
	},
	"retrieveUser": {
		"accountInfo": "Информация об аккаунте",
		"pleasePn": "Введите PN устройства",
		"forgetUser": "Забыл аккаунт",
		"phone": "Номер телефона привязанный к вашему аккаунту",
		"Return_to_login": "Вернуться к вводу пароля",
		"illustrate": "Если вы забыли свою учетную запись, вы можете получить подсказки с информацией об учетной записи, введя PN-номер любого устройства под вашей учетной записью, что поможет вам восстановить свой аккаунт!",
		"pnError": "Введеный PN некорректен",
		"comfig": "Подтвердить",
		"pnErrorMsg": "Регистратор данных не найден",
		"user": "Ваше имя",
		"email": "E-mail привязанный к вашему аккаунту",
		"pn": "Введите PN любого устройства из вашего аккаунта"
	},
	"device": {
		"cancel": "Отмена",
		"year": "Электроэнергия в текущем году",
		"deleteSuc": "Успешно удалено!",
		"pageSize": "Размер страницы",
		"noDataPlease": "Полномочия лица",
		"Battery_voltage": "Напряжение батареи",
		"select_file": "Пожалуйста выберите прошивку",
		"confirm_deldte": "Подтвердить удаление?",
		"brandDevice": "Устройство",
		"familyLoad": "Домашняя нагрузка",
		"solar": "Солнечная энергия",
		"clear_data": "Очистить данные",
		"universal_firmware": "Универсальная прошивка",
		"select_brate": "Пожалуйста выберите скорость обмена данными",
		"Send_Command": "Отправить команду",
		"showParam": "Показать параметры",
		"gridPower": "Мощность сети",
		"brand3": "Блок накопления энергии",
		"upgrade": "Пакетное обновление",
		"brand2": "Инвертор",
		"In_Upgrading": "Устройство или регистратор данных уже находятся в обновлении",
		"edit": "Редактировать",
		"brand1": "Автономный инвертор",
		"brand0": "Устройство хранения энергии",
		"analysis": "Анализ параметров",
		"Cumulative_income": "Общая прибыль от производства электроэнергии",
		"sellProfit_Today": "Поступления от продажи электроэнергии в этот день ",
		"sellProfit_Total": "Общий доход от продажи электроэнергии",
		"buyProfit_Today": "Покупка электроэнергии в тот же день ",
		"buyProfit_Total": "Общие расходы на электроэнергию",
		"pvPower": "Выработка электроэнергии",
		"cur_thismonth": "За этот месяц",
		"modify_alias": "Изменить устройство",
		"Device_sn": "Серийный номер устройства",
		"device_code": "Протокол",
		"alternator": "Генератор",
		"detail": "Деталь",
		"charged": "Энергия заряда",
		"device": "Устройство",
		"cur_day": "День",
		"datalogger_pn": "Номер регистратора данных",
		"Equipment_agreement": "Соглашение об оборудовании",
		"loadPower": "Мощность нагрузки",
		"standby": "Режим ожидания",
		"timeSlot": "Временной интервал",
		"select_type": "Пожалуйста, выберите тип прошивки",
		"alarmInfo": "Информация о тревожном сигнале",
		"battery": "Батарея",
		"Successfully_modified": "Успешно изменено",
		"offline": "Не в сети",
		"default": "По умолчанию",
		"copy_val_no": "Ошибка копирования",
		"Upgrading": "Обновление, подождите",
		"copy_val_yes": "Успешное копирование",
		"Send_fail": "Ошибка отправки команды",
		"control_firmware_bms": "Прошивка BMS",
		"person_authority": "Права администратора",
		"distribute": "Отправить",
		"optionTitle": "Выбран ",
		"optionTitle1": "Пункт ",
		"optionTitle2": "Выбор параметров устройства не должен превышать 4. ",
		"optionTitle4": "Выбор параметров устройства не должен превышать 12. ",
		"optionTitle3": "Пожалуйста, не выбирайте более двух вариантов.",
		"clause": "Детализация данных",
		"debug_suc": "Успешная отладка",
		"set": "Установить",
		"refresh": "Обновить",
		"inverter": "Инвертор",
		"clear_val": "Очистить данные",
		"protocolStatistic": "Статистика протокола",
		"dataloggerList": "Список регистраторов данных",
		"confirm": "Подтвердить",
		"queryUpgrade": "Ход обновления пакетного запроса",
		"device_cloudsUpgrade": "Прошивка:",
		"Debugfail": "Ошибка отладки, оборудование отключено.",
		"chart": "Диаграмма данных",
		"Sn_deviceName": "SN / Название устройства / PN / Пользователь",
		"current_val": "Текущее значение",
		"upFailDevice": "Неудачное обновление устройства",
		"copy_val": "Копировать",
		"User_belong": "Пользователь",
		"deviceName": "Имя устройства",
		"frequency": "Частота",
		"cloudUpgrade": "Облачное обновление",
		"Device_pn": "Номер журнала данных:",
		"generated": "Генерируемая энергия",
		"deviceList": "Устройство",
		"warning": "Предупреждение",
		"device_address": "Адрес устройства",
		"energyFlow": "Энергетическая эффективность",
		"upgrade_brate": "Скорость передачи данных:",
		"batteryPower": "Заряд батареи",
		"firmware_type": "Тип прошивки:",
		"add": "Добавить",
		"dataTips": "Текущее устройство находится в автономном режиме и не имеет данных в реальном времени.",
		"upDevice": "Обновление устройства",
		"statistic": "Статистика",
		"loadMore": "Загрузить больше ...",
		"firmware_package_message": "Пожалуйста выберите прошивку",
		"Please_parameter": "Пожалуйста, выберите параметр",
		"Allthemachines": "Все устройства",
		"deviceNo": "Вы еще не добавили устройство",
		"firmware_step_message": "Пожалуйста введите начальный шаг",
		"pro": "Проект",
		"deviceInfo": "Информация об устройстве",
		"moveSuc": "Успешно перемещено",
		"month": "Электроэнергия за текущий месяц",
		"return_content": "Вернуть содержимое:",
		"ownerShip": "Смена владельца",
    "oldOwner": "Предыдущий владелец:",
    "nweOwner": "Новый владелец:",
    "loading": "Загрузка...",
    "moreLoading": "Прокрутите, чтобы загрузить больше",
		"pleaseDate": "Пожалуйста выберите дату",
		"baudrate_message": "Пожалуйста выберите скорость обмена данными",
		"unfollow": "Отписаться",
		"upgradeProgress": "Текущий прогресс обнолвения",
		"file_fist": "Сначала выберите прошивку",
		"device_model": "Модель устройства",
		"followList": "Сосредоточиться на оборудовании",
		"continueUpgrade": "Продолжить обновление",
		"device_name": "Имя устройства",
		"Magnification": "Увеличение",
		"Today_income": "Доходы от производства электроэнергии в тот же день",
		"addUpgradeSuccess": "Добавлено успешно",
		"numberRlues": "Пожалуйста введите корректное количество шагов",
		"normal": "Нормальный",
		"sold": "Энергия продана",
		"overview": "Обзор статистики",
		"coll_alias": "Имя регистратора данных",
		"device_upgradeStatus": "Статус обновления",
		"relay": "Реле",
		"consumption": "Нагрузка",
		"Check_all": "Отметить все",
		"cur_month": "Месяц",
		"noAuth": "Нет пользователя, нет разрешения на просмотр",
		"step": "Стартовые шаги",
		"edit_control": "Изменить разрешения на управление устройствами",
		"noDate": "Невозможно выбрать будущую дату",
		"device_upgrade": "Обновление прошивки устройства",
		"chosenParam": "Выбранный параметр",
		"updatefail": "Ошибка обновления, устройство не в сети.",
		"device_pn": "PN",
		"administrator_cansee": "Выбранные разрешения видны подчиненному администратору, а делегат не виден.",
		"Instruction": "Инструкция:",
		"device_upgradeTime": "Время обновления",
		"Send_suc": "Отправить команду успешно",
		"Cancel_all": "Отменить все",
		"discharged": "Энергия разряда",
		"communication_firmware": "Коммуникационная прошивка",
		"cur_today": "Сегодня",
		"deviceDebug": "Запуск оборудования",
		"generation": "PV",
		"Datalogger_belong": "Регистратор данных",
		"field": "Полевой контроль",
		"defaultUpgrade": "Обновление по умолчанию",
		"reset": "Перезагрузить",
		"person_cansee": "Выбранные разрешения видны владельцу, а делегат не виден.",
		"device_alias": "Имя устройства:",
		"minSelect": "Необходимо проверить как минимум 1 параметр.",
		"deviceUpgradeProgress": "Прогресс обновления",
		"maxSelect": "Только 7 параметров могут быть проверены максимум",
		"Output_table": "Выходная таблица",
		"Upload": "Загрузить",
		"Input_form": "Входная таблица",
		"upgrade1": "Обновление",
		"more": "Больше действий",
		"one_click_read": "Читать в один клик",
		"device_code_form": "Протокол:",
		"power": "Мощность",
		"device_sn": "Серийный номер устройства",
		"bought": "Энергия куплена",
		"cur_thisyear": "В этом году",
		"upSuccessDevice": "Устройство успешно обновлено",
		"proList": "Список проектов",
		"serial_number": "Серийный номер устройства:",
		"grid": "Сеть",
		"control_firmware_slavmcu": "Прошивка SlavMCU",
		"report": "Отчет",
		"upgradeType": "Способ обновления",
		"device_upgrade1": "Последняя запись об обновлении",
		"uploadSuccess": "Загрузка прошла успешно",
		"Current_data": "Текущие данные",
		"Upload1": "Загрузить новую прошивку",
		"Send_Input": "Пожалуйста, введите значение операции для отправки",
		"device_type": "Тип устройства",
		"selecParameters": "Выбранный параметр",
		"used": "Использованная энергия",
		"System_Failed": "Системе не удалось запустить процесс обновления устройства из-за аномалий связи или по другим причинам.",
		"Unit": "Единица",
		"modifySuc": "Успешно изменено",
		"cur_year": "Год",
		"firmware_type_message": "Пожалуйста выберите тип",
		"such_as": "Введите свою команду, например: AA BB CC DD EE FF",
		"day": "Текущая мощность",
		"obtain": "Получить",
		"all": "Всего электроэнергии",
		"device_status": "Состояние устройства",
		"read": "Считать",
		"deleteDevice": "Удалить устройство",
		"update_suc": "Успешно обновлено",
		"admin_authority": "Нет данных, выберите другое время",
		"continueUpgradeSuccess": "Успешно обновлено и добавлено",
		"send": "Отправить",
		"control_firmware1": "Прошивка управления 1",
		"datalogger": "Список устройств",
		"control_firmware2": "Прошивка управления 2",
		"device_upgradeProgress": "Прогресс обновления",
		"Operation": "Работать",
		"delete": "Удалить",
		"addUpgrade": "Добавить задачу на обновление",
		"Device_Offline": "Устройство или регистратор данных отключены",
		"Field_Name": "Имя поля",
		"device_upgradeFirmware": "Выберите пакет прошивки для обновления устройства",
		"Voltage": "Напряжение",
		"Update_Completed": "обновление завершено",
		"parameter": "Параметр",
		"device_continueUpgrade": "Оборудование продолжает обновляться",
		"moveResults": "Переместить результаты",
		"value": "Величина",
		"chooseProtocol": "Выберите протокол:",
		"optionalParam": "Дополнительный параметр",
		"fileExceed": "Превышен размер файла",
		"debug": "Отладка",
		"Electric": "Электрический",
		"fault": "Ошибка",
		"control": "Контроль",
		"select_firmware": "Пожалуйста, выберите файл прошивки",
		"follow": "Подписаться",
		"upBatchDeviceTip": "Примечание. Пакетное обновление предназначено для обновления прошивки одного и того же устройства для нескольких устройств. Если вы не знаете, какая прошивка подходит для вашего устройства, пожалуйста, выбирайте внимательно!",
		"cloudsUpgrade": "Облачное обновление",
		"device_upgradeName": "Название обновления прошивки",
		"instruction_response": "Отправка инструкции, ожидание ответа...",
		"error1": "Загружать можно только файлы в форматах .bin и .hex!",
		"dataview": "Параметры реального времени"
	},
	"account": {
		"cancel": "Отмена",
		"Delete": "Удалить",
		"enterHome": "Возврат",
		"reason1": "Нет данных по оборудованию",
		"reason": "Причиной отсутствия отображения графика может быть:",
		"role1": "Тип пользователя:",
		"reason2": "В договоре на оборудование нет полей параметров выработки электроэнергии, потребляемой мощности, покупной мощности, продаваемой мощности, зарядной мощности и разрядной мощности.",
		"projects": "Проекты",
		"reason3": "Протокол оборудования не имеет параметров выработки электроэнергии, мощности нагрузки, мощности батареи и мощности сети.",
		"resetPwdSuc": "Сброс пароля успешен!",
		"newPwd": "Новый пароль",
		"deleteSuc": "Успешно удалено!",
		"binding": "Связать",
		"Edit": "Редактировать",
		"groupsuccess": "Группа успешно увеличилась!",
		"createSuc": "Создание учетной записи успешно!",
		"generalAccount": "Основной аккаунт",
		"Individual_allocation": "Индивидуальное распределение",
		"password": "Пароль",
		"enablesuccess": "Успешно включено!",
		"enable": "Включить",
		"searchPro": "Поиск проекта",
		"accountManage": "Аккаунт",
		"relatedOwner": "Связанный владелец",
		"confirmpassword": "Подтвердите пароль",
		"nickname1": "Псевдоним:",
		"Assigned_successfully": "Назначено успешно",
		"Confirm_assignment": "Подтвердить назначение",
		"selectUserType": "Пожалуйста, выберите тип пользователя!",
		"PNNum": "PN",
		"devices": "Устройства",
		"deletegroup": "Выйти из этой группы",
		"adminRelated": "Пожалуйста, выберите администратора",
		"createAccount": "Создать",
		"operate": "Работать",
		"groupManage": "Управление группой",
		"Distribution_method": "Метод распространения",
		"IsIt": "это",
		"userAccount": "Пользователь",
		"deleteUser": "Удалить пользователя",
		"projectNum": "Количество устройств",
		"deletegroupsuccess": "Выход из группы успешен!",
		"afterEnable": "После включения учетную запись можно восстановить для входа в систему, просмотра или изменения соответствующего содержимого учетной записи.",
		"changeGroupSuc": "Изменить группу успешно!",
		"role": "Тип пользователя",
		"disablesuccess": "Отключено успешно!",
		"groupto": "Сгруппировать в",
		"Distribution_collector": "Distribution collector",
		"confirmDisable": "Подтвердить отключение этого пользователя?",
		"accountStatus": "Статус аккаунта",
		"groupAccount": "Группа",
		"defaultGroup": "Группа по умолчанию",
		"nickname": "Псевдоним",
		"password1": "Пароль:",
		"email": "Электронная почта",
		"order_check": "Проверить",
		"relatedSuccess": "Объединение прошло успешно",
		"Deletesuccessfully": "Удаление аккаунта успешно!",
		"powerStationOwner": "Владелец станции",
		"err_orderNum": "В порядке",
		"tooltipContent": "Администратор может назначить все сборщики данных под заказ подчиненному дилеру через номер заказа",
		"distributor": "Дистрибьютор",
		"Allocation_result": "Результат распределения",
		"confirm": "Подтвердить",
		"ownedDevices": "Собственные устройства",
		"resetPwd": "Сброс пароля",
		"activeStatus": "Активный статус",
		"createTime": "Время создания",
		"placeholder1": "Введите одно имя пользователя / номер мобильного телефона",
		"disable": "Отключить",
		"accounts": "Счета",
		"lastLogin": "Последний вход",
		"allGroup": "Все группы",
		"confirmpassword1": "Подтвердите пароль:",
		"editUser": "Изменить пользователя",
		"cannotRedirect": "Эта учетная запись не является учетной записью хранения энергии, перенаправление невозможно!",
		"modifiedsuccess": "Информация о пользователе успешно изменена!",
		"email1": "Электронная почта:",
		"manageAccount": "Управленческий аккаунт",
		"Order_allocation": "Распределение заказа",
		"finish": "Закончить",
		"group": "Группа",
		"changeGroup": "Изменить группировку на:",
		"limitFormat": "Загружать можно только файлы в форматах xlsx и xls",
		"ascription": "Принадлежность",
		"ascriptionSuccess": "Принадлежность успешно",
		"ascription_result": "Результаты атрибуции",
		"newPwd1": "Новый пароль:",
		"group1": "Группа:",
		"disableSuc": "Успешное отключение учетной записи!",
		"currentTotal": "Текущий",
		"uselists": "Список управления пользователями",
		"powerStationViewer": "Наблюдатель за электростанцией",
		"afterDisable": "После отключения учетная запись не сможет войти в систему, а соответствующее содержимое учетной записи нельзя будет просмотреть или изменить.",
		"unclassified": "Неклассифицированный",
		"submit": "Представить на рассмотрение",
		"newPwdEmpty": "Новый пароль не может быть пустым, пожалуйста, заполните его!",
		"accountName": "Имя пользователя",
		"pwdresetsuccess": "Пароль успешно сброшен!",
		"order_number": "Номер заказа",
		"mobile1": "Мобильный:",
		"admin": "Администратор",
		"riyueyuan_lineSonAdmin": "Подадминистратор производственных линий",
		"riyueyuan_SonAdmin": "Подадминистратор",
		"plantOwner": "Владелец станции",
		"accountName1": "Имя пользователя",
		"accountName2": "введите одно имя пользователя",
		"Batch_allocation": "Пакетное распределение",
		"deviceNum": "Устройство",
		"chooseGroup": "Пожалуйста, выберите группу",
		"editAccount": "Редактировать аккаунт",
		"notRecovered": "После удаления восстановление невозможно...",
		"placeholder": "Поиск Имени пользователя / номера мобильного телефона",
		"accountRole": "Роль",
		"Ple_orderNum3": "коллекторы, подтвердите выделение",
		"Ple_orderNum2": "Этот заказ имеет",
		"Ple_orderNum": "Пожалуйста, введите номер заказа",
		"Ple_orderNum1": "Пожалуйста, введите правильный номер заказа",
		"lastLoginTs": "Время последнего входа",
		"mobile": "Телефон",
		"accountGroup": "Группа пользователей",
		"nodata": "Нет данных",
		"allTypeUser": "Все типы пользователей",
		"confirmDelete": "Подтвердить удаление?",
		"confirmEnable": "Подтвердить включение этого пользователя?",
		"dataloggerNum": "Регистраторы данных",
		"allAccount": "Все пользователи",
		"err_orderNum1": "Регистраторы данных были связаны. Пожалуйста, подтвердите, что регистраторы в заказе не связаны",
		"accountList": "Список учетных записей",
		"dataogger_swith": "Добавить числовой искатель",
		"dataogger_swithTip": "Может ли учетная запись иметь права на добавление",
		"account_number": "Номер счета",
		"Role_authority": "Полномочия",
		"authority_Management": "Управление правами",
		"Related_roles": "Ассоциированные роли",
		"Ple_role1": "Выберите ассоциированную роль",
		"Ple_role2": "Введите имя / ID роли",
		"Add_role": "Новые роли",
		"Edit_role": "Редактировать роль",
		"Role_id": "Идентификатор роли",
		"Role_name": "Название роли",
		"Ple_role3": "Введите имя персонажа",
		"Role_des": "Описание роли",
		"Ple_role4": "Введите описание роли",
		"module": "Модуль",
		"First_page": "Страницы",
		"Secondary_page": "Две страницы",
		"Function_points": "Функции",
		"Remove_role": "Удалить роль",
		"Ple_role5": "Пожалуйста, выберите номер счета.",
		"No_permission_prompt": "Без прав, свяжитесь с вышестоящим администратором",
		"Ple_role6": "Имя персонажа уже существует, введите его заново",
		"limit_UserTypeNum": "Превышение ограничений, тип аккаунта уже существует",
		"limit_UserTypeDataPermission": "Аккаунты дилеров не могут связывать роли с выбранными разрешениями на данные.",
		"edit_limit_UserTypeDataPermission": "Роль связана с учетной записью дилера, и разрешения на данные не могут быть отредактированы.",
		"dataPermission": "Разрешение на данные",
		"functionalPermission": "Функциональное разрешение"
	},
	"browse": {
		"pleaseUsr": "Введите суб-аккаунт",
		"deleteBrowse": "Удалить",
		"pleaseDevice": "Выбрать",
		"editBrowse": "Редактировать суб-аккаунт",
		"addSuccess": "Успешно добавлен суб-аккаунт",
		"password": "Пароль",
		"usr": "Суб-аккаунт",
		"pleaseDevice_title": "Пожалуйста выберите проект",
		"deleteSuccess": "Успешно удалено!",
		"confirmPassword": "Подтвердите пароль",
		"Enable": "Включить",
		"Disable": "Отключить",
		"email": "Электронная почта",
		"accountInfo": "Информация об аккаунте",
		"delete_browse": "Вы точно хотите удалить этот суб-аккаунт?",
		"addBrowse": "Добавить суб-аккаунт",
		"gts": "Дата регистрации",
		"mobile": "Телефон",
		"newPassword": "Новый пароль",
		"editSuccess": "Успешно отредактирован суб-аккаунт",
		"please_browsepwd": "Проверьте новый пароль и подтвердите требования к вводу пароля",
		"pleaseStatus": "Выбрать статус",
		"device": "Выбор проекта",
		"usrInfo": "Информация о пользователе",
		"enableStatus": "Подтвердить статус",
		"username": "Имя пользователя",
		"desc": "Замечания"
	},
	"collectionFrequencyUP": {
		"collect_fast": "Ускорение сбора данных о потоке энергии",
		"collect_fast2": "Ускорение потока энергии",
		"collect_fast_fail": "Не удалось выполнить ускорение, попробуйте еще раз",
		"collect_fasting": "Ускорение",
		"collect_fast_starting": "Запуск ускорения",
		"collect_fast1": "Ускорение сбора детализированных данных",
		"collect_fast1ing": "Данные ускоряются.",
		"paySecCon": "Подтверждение платежа",
		"energyFetchPic": "Подтвердить ли пополнение, диапазон ускорения пополнения для параметров страницы диаграммы потока энергии, как показано ниже",
		"historyFetchPic": "Подтвердить ли пополнение, диапазон ускорения пополнения для детальных параметров страницы данных, как показано на рисунке ниже",
		"reRechargeTip1": "Для текущего устройства уже куплена услуга ускорения потока энергии. Продолжение покупки снова приведёт к списанию средств. Продолжить?",
		"reRechargeTip": "Для текущего устройства уже куплена услуга ускорения детальных данных. Продолжение покупки снова приведёт к списанию средств. Продолжить?",
		"continueRecharge": "Продолжить пополнение",
		"collect_fasting_title": "Параметры в реальном времени не сохраняются",
		"collect_Order_Record": "Ускорение записи",
		"Collection_terms": "Условия ускоренного пополнения частоты сбора",
		"Recharge_failed_next": "Извините за неудачное пополнение, вы можете попытаться заплатить снова",
		"view_order": "Посмотреть заказ",
		"Once": "А",
		"every_interval": "Текущая выбранная спецификация ускорения: каждый интервал",
		"Collect_terms2": "Сфера применения пакетов",
		"Collect_terms3": "Параметры отображения, включенные в протокол, используемый сборщиком для пополнения (примечание: если вы выбрали страницу диаграммы потока для ускоренного пополнения, сфера применения пакета ограничена диапазоном параметров отображения страницы диаграммы потока; если выбранная вами страница исторических данных для ускоренного пополнения, сфера применения пакета ограничена диапазоном параметров отображения страницы исторических данных)",
		"Collect_terms4": "II. Отсутствие поддержки соглашений / оборудования о замене",
		"have_read": "Я полностью прочитал",
		"Collect_terms5": "Соглашение о замене / оборудование не участвует в ускоренном доступе",
		"Collect_terms6": "III. Отзывы о пакете",
		"Collect_terms": "Условия ускоренного пополнения",
		"View_Details": "Посмотреть подробнее",
		"Recharge_result": "Результаты пополнения",
		"Collect_terms7": "Отказ от подписки и изменений после оплаты не поддерживается",
		"Online_payment": "Платежи онлайн",
		"Collect_terms8": "4 Цены на пакеты",
		"Collect_terms9": "Наши тарифы представляют собой конечную цену, рассчитанную на основе вашего количества параметров, ускоренной частоты сбора и загрузки; В дополнение к вышеуказанным условиям исторические данные касаются времени хранения.",
		"acquisition_frequency": "Частота сбора",
		"Recharge_failed": "Ошибка перезарядки",
		"Recharge_amount": "Пополнить баланс",
		"Scan_payment": "Подсчитывание платежей",
		"collect_recharge": "Перезагрузка ускорения сбора данных (ускорение сбора детализированных данных)",
		"collect_recharge1": "Перезагрузка ускорения сбора данных (ускорение потока энергии)",
		"Collect_terms10": "V. Потребление трафика",
		"Purchase_Terms7": "Есть и другие вопросы.",
		"Purchase_Terms8": "Если у вас есть другие вопросы, которые вы можете проконсультировать с нашим онлайн - сервисом, мы ответим на них подробно.",
		"Collect_terms11": "Ускорение сбора частот увеличивает расход трафика",
		"Purchase_Terms6": "Наши тарифы представляют собой конечную цену, рассчитанную на основе вашего количества параметров, ускоренной частоты сбора и загрузки; В дополнение к вышеуказанным условиям исторические данные касаются времени хранения.",
		"Purchase_Terms5": "Цены на пакеты",
		"Purchase_Terms4": "Пожалуйста, с нетерпением ожидайте нашей новой версии, текущая версия поддерживает только сбор и обновление всех параметров дисплея, создавая неудобства, пожалуйста, поймите!",
		"Purchase_Terms3": "Не можете настроить частоту для некоторых параметров?",
		"Real_parameters": "Параметры реального времени",
		"Purchase_Terms1": "Срок действия ускорения сбора данных",
		"Purchase_Terms2": "Срок истечения услуги ускорения сбора данных будет автоматически рассчитан на основе продолжительности приобретённого вами пакета. Точный срок истечения указан на странице",
		"device_Info": "Информация об устройстве",
		"Recharge_successful_next": "Поздравляю с успешным пополнением, мы собираемся обновить частоту сбора для вас, и вы можете следить за изменениями частоты сбора с этого момента",
		"Purchase_Terms": "Условия покупки",
		"gather": "Сбор",
		"Recharge_time": "Время",
		"Payment_method": "Способы оплаты",
		"Type": "Тип пополнения",
		"Recharge_now": "Пополнить счет сейчас",
		"History_Data": "Исторические данные",
		"Collect_terms1": "Условия Ускорения службы сбора частот",
		"Package": "Ускоренное питание.",
		"PN_order": "PN / Номер заказа",
		"Order_No": "Номер заказа",
		"Recharge_successful": "Пополнение успешно",
		"noRecharg": "Коллектор не поддерживает пополнение",
		"noRecharg_min": "У вас самый быстрый сбор!",
		"noRecharg_wifi": "Текущая версия поддерживает только цифровые устройства Wi - Fi модулей",
		"paypalTip": "Окончательная сумма платежа зависит от PayPal",
		"upPrice": "Разница в ценах",
	},
	alarmNew: {
		'fileName': 'Имя файла',
		'fileSize': 'Размер файла',
		'fileStatus': 'Статус файла',
		'progress': 'Прогресс',
		'can': 'Можно скачать',
		'no': 'Экспортируется',
		'history': 'История экспорта'
	},
		shuoriExport:{
        "exportRecords": "Экспорт записей",
        "export": "Экспортировать",
        "exportTask": "Задача экспорта создана. Пожалуйста, скачайте файл позже в разделе «Экспорт записей».",
        "noDownload": "Адрес файла недействителен или невозможно скачать файл. Пожалуйста, попробуйте снова.",
		'data': 'дата',
	},
		colUnBindRecord: {
	'UnBindRecord': 'Запись об отвязке сборщика данных',
    "unStatus": "Статус отвязки",
    "unScene": "Сценарий отвязки",
    "oldUser": "Исходный пользователь",
    "newUser": "Новый пользователь",
    "unCount": "Количество отвязок",
    "pnBarCode": "Штрихкод номера детали (PN)",
    "devicePicture": "Фото устройства (реальное)",
    "ip": "Отвязанный IP",
    "unTime": "Время отвязки"
	},
		rosRecharge: {
		'electronicInvoicing': 'Электронное выставление счёта',
		'issueEInvoice': 'Выставить электронный счёт',
		'invoiceHistory': 'История счетов',
		'rechargeDuration': 'Длительность пополнения',
		'year': 'год',
		'month': 'месяц',
		'day': 'день',
		'days': 'дней',
		'pendingPayment': 'Ожидание оплаты',
		'paymentSuccess': 'Оплата успешна',
		'paymentFailed': 'Ошибка оплаты',
		'orderClosed': 'Заказ закрыт',
		'serviceTerminated': 'Услуга прекращена',
		'unpaid': 'Не оплачено',
		'paying': 'Оплачивается',
		'paid': 'Оплачено',
		'refunded': 'Возвращено',
		'cancelled': 'Отменено',
		'rechargeSuccess': 'Пополнение успешно',
		'rechargeFailed': 'Ошибка пополнения',
		'pleaseSelectDate': 'Выберите дату',
		'orderNo': 'Номер заказа',
		'batchInvoicing': 'Пакетное выставление счетов',
		'rechargeType': 'Тип пополнения',
		'trafficRecharge': 'Пополнение трафика',
		'collectRecharge': 'Пополнение сбора',
		'rechargeStatus': 'Статус пополнения',
		'invoice': 'Счёт',
		'invoiceStatus': 'Статус счёта',
		'invoiceTime': 'Время выставления счёта',
		'viewDetail': 'Просмотр деталей',
		'invoicing': 'Выставление счёта',
		'invoiceSuccess': 'Счёт выставлен',
		'invoiceFailed': 'Ошибка выставления счёта',
		'issueElectronicInvoice': 'Выставить электронный счёт',
		'invoiceType': 'Тип счёта',
		'generalInvoice': 'Обычный счёт',
		'specialInvoice': 'Специальный счёт',
		'headerType': 'Тип заголовка',
		'companyHeader': 'Заголовок компании',
		'personalHeader': 'Личный/Некорпоративный заголовок',
		'pleaseInputCompanyHeader': 'Введите заголовок компании',
		'taxNumber': 'ИНН компании',
		'pleaseInputTaxNumber': 'Введите идентификационный номер налогоплательщика',
		'headerName': 'Название заголовка',
		'suggestPersonalName': 'Рекомендуется указать имя/название магазина',
		'invoiceContent': 'Содержание счёта',
		'internetCommService': 'Услуги интернет-связи',
		'invoiceAmount': 'Сумма счёта',
		'yuan': 'руб.',
		'moreInfo': 'Дополнительная информация',
		'remarkAddressEtc': 'Примечания, адрес и т.д.',
		'companyAddress': 'Адрес компании',
		'pleaseInputCompanyAddress': 'Введите адрес компании',
		'companyPhone': 'Телефон компании',
		'pleaseInputCompanyPhone': 'Введите телефон компании',
		'openingBank': 'Банк счёта',
		'pleaseInputOpeningBank': 'Введите название банка',
		'bankAccount': 'Банковский счёт',
		'pleaseInputBankAccount': 'Введите номер банковского счёта',
		'remark': 'Примечание',
		'pleaseInputRemark': 'Введите примечание',
		'email': 'Электронная почта',
		'pleaseInputEmail': 'Введите адрес электронной почты',
		'cancel': 'Отмена',
		'submit': 'Отправить',
		'invoiceResult': 'Результат выставления счёта',
		'invoiceSubmitted': 'Заявка на счёт подана',
		'invoiceExpectedTip': 'Счёт будет выставлен в течение 48 часов, пожалуйста, проверьте почту',
		'viewInvoiceStatus': 'Просмотр статуса счёта',
		'pleaseInputHeaderName': 'Введите название заголовка',
		'pleaseInputValidEmail': 'Введите корректный адрес электронной почты',
		'invoiceApplyFailed': 'Заявка на счёт не выполнена',
		'viewInvoice': 'Просмотр счёта',
		'downloadPdf': 'Скачать PDF-файл',
		'manualService': 'Служба поддержки',
		'invoiceSentToEmail': 'Информация о счёте отправлена на почту, пожалуйста, проверьте',
		'pleaseWaitInvoicing': 'Пожалуйста, подождите завершения выставления счёта',
		'pleaseContactManual': 'Пожалуйста, обратитесь в службу поддержки для выставления счёта',
		'noPdfAvailable': 'Нет PDF-файлов для скачивания',
		'serviceUnavailable': 'Функция службы поддержки временно недоступна',

	}
}
export default ru;
